//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import DataTable from '../../general/DataTable';
import MixinBmi from './MixinBmi';
export default {
  name: 'WeightTable',
  components: {
    DataTable: DataTable
  },
  mixins: [MixinBmi],
  props: {
    data: {
      type: Array,
      default: null
    },
    person: {
      type: Object,
      default: null
    }
  },
  computed: {
    headerDefinition: function headerDefinition() {
      return [{
        name: t('health', 'Date'),
        columnId: 'date',
        type: 'date',
        show: true,
        default: function _default() {
          return new Date().toISOString().slice(0, 10);
        }
      }, {
        name: t('health', 'Weight'),
        columnId: 'weight',
        type: 'number',
        show: this.person.weightColumnWeight,
        suffix: this.person.weightUnit ? this.person.weightUnit : ''
      }, {
        name: t('health', 'BMI'),
        columnId: 'bmi',
        type: 'calculate',
        calc: function calc(dataset) {
          return this.calcData.bmiApi.methods.bmi(this.calcData.person, dataset.weight);
        },
        calcData: {
          person: this.person,
          bmiApi: MixinBmi
        },
        show: this.person.weightColumnBmi
      }, {
        name: t('health', 'Bodyfat'),
        columnId: 'bodyfat',
        type: 'number',
        show: this.person.weightColumnBodyfat,
        suffix: '%'
      }, {
        name: 'weightMeasurementName' in this.person && this.person.weightMeasurementName ? this.person.weightMeasurementName : t('health', 'Measurementdata'),
        columnId: 'measurement',
        type: 'number',
        show: this.person.weightColumnMeasurement
      }, {
        name: t('health', 'Waist size'),
        columnId: 'waistSize',
        type: 'number',
        show: this.person.weightColumnWaistSize,
        suffix: 'cm'
      }, {
        name: t('health', 'Hip size'),
        columnId: 'hipSize',
        type: 'number',
        show: this.person.weightColumnHipSize,
        suffix: 'cm'
      }, {
        name: t('health', 'Muscle part'),
        columnId: 'musclePart',
        type: 'number',
        show: this.person.weightColumnMusclePart,
        suffix: '%'
      }, {
        name: t('health', 'Comment'),
        columnId: 'comment',
        type: 'longtext',
        show: true
      }];
    }
  },
  methods: {
    addItem: function addItem(item) {
      // console.debug('add item', item)
      this.$store.dispatch('rWeightDatasetsAppend', item);
    },
    updateItem: function updateItem(item) {
      // console.debug('update item', item)
      this.$store.dispatch('rWeightDatasetsUpdate', item);
    },
    deleteItem: function deleteItem(item) {
      // console.debug('delete item', item)
      this.$store.dispatch('rWeightDatasetsDelete', item);
    }
  }
};